<label class="custom-tooltip" [innerHTML]="changeAsteriskStyle(params.value)">
</label>
